var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCautioncomponent = function SvgCautioncomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.75v3m0 2.25h.007M7.272 1.691l-6.08 10.15a1.436 1.436 0 0 0 1.227 2.154h12.16a1.435 1.435 0 0 0 1.228-2.152L9.727 1.692a1.435 1.435 0 0 0-2.455 0v0Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCautioncomponent;